import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { Calendar, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import Actions_Wind from '~/Actions_Wind';
import PageTitle from '~/components/PageTitle';

import DailyCard from './DailyCard';
import DailyReportGenerator from './DailyReportGenerator';
import Detail from '~/containers/Page_Main/Page_InfoManagement/Page_ProjectProgress/Page_PPDaily/Detail';

const Page_DailyReport = (props) => {
  const { clearList, getPPDailyList, PPDailyList, getWindId } = props;
  const [currentId, setCurrentId] = useState('');
  const [view_addAndEdit, setViewAddAndEdit] = useState(false);
  const [mode_addAndEdit, setModeAddAndEdit] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [date, setDate] = useState(moment());
  const [week, setWeek] = useState(6);
  const [opacity, setOpacity] = useState(0);
  const [transition, setTransition] = useState('');

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (PPDailyList) {
      setOpacity(1);
      setTransition('opacity 1s');
    }
  }, [PPDailyList]);

  const getData = (M) => {
    const m = M || moment();
    const m_s = moment(m).startOf('month');
    const minDate = m_s.subtract(m_s.day() + 1, 'days');
    const m_e = moment(m).endOf('month');
    const maxDate = m_e.add(6 - m_e.day(), 'days');

    setDate(M || date);
    setWeek((maxDate.diff(minDate, 'day') + 1) / 7);
    setOpacity(0);
    setTransition('');

    clearList();
    getPPDailyList({
      query_field: 'now_date',
      start_date: minDate.format('YYYY-MM-DD'),
      end_date: maxDate.format('YYYY-MM-DD'),
    }, 'noWindContractId');
  };

  const add = (currentDate) => {
    setViewAddAndEdit(true);
    setModeAddAndEdit('add');
    setCurrentDate(currentDate);
  };

  const edit = (currentId, currentDate) => {
    setCurrentId(currentId);
    setViewAddAndEdit(true);
    setModeAddAndEdit('edit');
    setCurrentDate(currentDate);
  };

  const closeViewAndEdit = (func = () => {}) => {
    getData(date);
    setCurrentId('');
    setViewAddAndEdit(false);
    setModeAddAndEdit('');
    setCurrentDate('');
    func();
  };

  const renderDay = (day, selectedDate, dayInCurrentMonth, dayComponent) => {
    const currentDate = day.format('YYYY-MM-DD');
    const isToday = moment().format('YYYY-MM-DD') === currentDate;
    const data = PPDailyList?.find(o => moment(new Date(o.now_date)).format('YYYY-MM-DD') === currentDate) || null;

    const haveData = !!data;

    const onClick = () => {
      if (haveData) edit(data.id, currentDate);
      else add(currentDate);
    };
    const overToday = !isToday && day > moment();
    const cardProps = {
      day,
      dayInCurrentMonth,
      isToday,
      onClick,
      data,
      haveData,
      overToday,
    };
  
    return <DailyCard {...cardProps} />;
  };  

  const mainPage = () => {
    const h = 920 + (week - 5) * 160;
    return (
      <div
        style={{
          position: 'absolute',
          left: 13,
          right: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          overflow: 'auto',
          backgroundColor: 'white',
        }}
      >
        <PageTitle text='每日進度' />
        <div style={{ minHeight: 8 }} />
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {opacity === 0 && <CircularProgress style={{ color: '#B2D6DB' }} />}
          <div style={{ width: 757, height: h, backgroundColor: '#F9F9F9', borderRadius: 30, opacity, transition }}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <Calendar
                date={date}
                renderDay={renderDay}
                onMonthChange={getData}
                onChange={(date, isFinish) => { }}
                maxDate={moment()}
              />
            </MuiPickersUtilsProvider>
          </div>
        </div>
      </div>
    );
  };

  return view_addAndEdit
    // ? <Detail id={currentId} mode={mode_addAndEdit} _onClose={closeViewAndEdit} currentDate={currentDate} _edit={edit} />
    ? <DailyReportGenerator currentDate={currentDate} onBack={closeViewAndEdit} />
    : mainPage();

};


const mapStateToProps = state => ({
  PPDailyList: (state.data.PPDailyList || {}).list,
});

const mapDispatchToProps = dispatch => ({
  clearList: () => Actions_Wind.clearKey(dispatch, { key: 'PPDailyList' }),
  getWindId: () => Actions_Wind.wind_id(),
  getPPDailyList: (body, windId) => Actions_Wind.getPPDailyList(dispatch, { body, windId }),
});


export default connect(mapStateToProps, mapDispatchToProps)(Page_DailyReport);